<template>
  <div class="burger-menu" :class="classMenu">
    <Logo />
    <el-scrollbar
      class="burger-menu__scrollbar"
      wrap-class="burger-menu__scrollbar--wrapper">
      <Menu />
    </el-scrollbar>
    <footer
      v-if="showNumClient"
      class="burger-menu__footer">
      <span class="burger-menu__footer__label">
        {{ $t('layout.navbar.fileNumber') }}
      </span>
      <span class="burger-menu__footer__value">
        {{ projectSelected.num_client }}
      </span>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useProjectStore } from '@/stores';
import Logo from '@/components/layout/Logo.vue';
import Menu from '@/components/layout/Menu.vue';

export default {
  name: 'burgerMenu',
  components: {
    Menu,
    Logo,
  },
  props: {
    isActived: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    ...mapState(useProjectStore, {
      projectSelected: 'projectSelected',
      projects: 'projects',
    }),
    classMenu() {
      return {
        'burger-menu--active': this.isActived,
      };
    },
    showNumClient() {
      return this.projects.length === 1 && this.projectSelected?.num_client;
    },
  },
  watch: {
    isActived(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    },
  },
};
</script>

<style lang="scss">

.burger-menu {
  position: fixed;
  display: flex;
  flex: 1 1 0%;
  flex-direction: column;
  height: 100%;
  height: 100dvh;
  width: var(--nxt-left-menu-size);
  left: calc(var(--nxt-left-menu-size) * -1);
  top: 0;
  bottom: 0;
  background-color: var(--nxt-color-light-grey);
  z-index: 1001;
  transition: all .5s ease;
  overflow-x: hidden;

  &__scrollbar {
    flex: 1;
    min-height: 0;
    width: 100%;
    overflow-x: hidden;

    &--wrapper {
      overflow-y: auto !important;
      overflow-x: hidden !important;

      .el-scrollbar__view {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        overflow-x: hidden;
      }
    }
  }

  &__footer {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 12px 12px calc(12px + env(safe-area-inset-bottom, 0px));
    background-color: var(--nxt-color-white);
    border-top: 1px solid var(--nxt-color-light-grey);
    color: var(--nxt-color-primary);

    &__label {
      font-size: 12px;
      line-height: 16px;
      text-transform: uppercase;
      letter-spacing: 0.02em;
      opacity: 0.7;
    }

    &__value {
      font-size: 18px;
      line-height: 24px;
      font-weight: 700;
    }
  }

  &--active {
    box-shadow: 0 0 2rem 0 rgba(0,0,0,.2);
    left: 0;
  }
}
</style>
